import { useCallback, useMemo, useRef, useState } from 'react'
import type { RightPanelRequest, RightPanelValue } from './rightPanelContext'

const useRightPanelState = () => {
  const [expanded, setExpanded] = useState(false)
  const [request, setRequest] = useState<RightPanelRequest>(null)
  const [handledRequestId, setHandledRequestId] = useState<number | null>(null)
  const [notifications, setNotifications] = useState<Record<string, number>>({})
  const requestCounter = useRef(0)

  const toggle = useCallback(() => setExpanded(current => !current), [])

  const openModule = useCallback((key: string) => {
    setExpanded(true)
    requestCounter.current += 1
    setRequest({ key, id: requestCounter.current })
  }, [])

  const markRequestHandled = useCallback((id: number) => setHandledRequestId(id), [])

  const setNotification = useCallback((key: string, count: number) => {
    setNotifications(previous => (previous[key] === count ? previous : { ...previous, [key]: count }))
  }, [])

  const panel: RightPanelValue = useMemo(
    () => ({ expanded, toggle, openModule, request, handledRequestId, markRequestHandled, setNotification }),
    [expanded, toggle, openModule, request, handledRequestId, markRequestHandled, setNotification],
  )

  return { panel, notifications }
}

export default useRightPanelState
